const formatCurrency = (amount) => {
  const options = {
    style: "currency",
    currency: "EUR",
  };

  if (typeof amount !== 'number') {
    return '-';
  }

  if (amount % 1 !== 0) {
    options.minimumFractionDigits = 2;
    options.maximumFractionDigits = 2;
  } else {
    options.minimumFractionDigits = 0;
    options.maximumFractionDigits = 0;
  }

  return new Intl.NumberFormat("de-DE", options).format(amount);
};

export default formatCurrency;
